'use strict';

// http://ecma-international.org/ecma-262/5.1/#sec-9.3

module.exports = function ToNumber(value) {
	return +value; // eslint-disable-line no-implicit-coercion
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/5/ToNumber.js
 ** module id = 2924
 ** module chunks = 0
 **/